import { useMarkupRates, usePeriodTypes, useUnitTypes } from "@/hooks/use-enums";
import { z } from "zod"; // import zod

// full schema type
export const bomSchema = z.object({
	id: z.string().optional().nullable(),
	item_name: z.string().optional().nullable(),
	brand_model: z.array(z.string()).default([]),
	brand_origin: z.array(z.string()).default([]),
	specifications: z.record(z.string(), z.string()).optional().nullable().default({}),
	markup_rate: z.string().optional().nullable(),
	additional_costs: z.record(z.string(), z.coerce.number()).optional().nullable().default({}),
	warranty: z.coerce.number().optional().nullable(),
	period: z.enum(["year", "month"]),
	// coerce, tells zod to CONVERT to number
	quantity: z.number().optional().nullable(),
	unit: z.enum(["each", "box", "roll", "set", "packs"]).default("each"),
	company_unit_cost: z.number().optional().nullable(),
	company_total_cost: z.number().optional().nullable(),
	bom_supplier_info_id: z.string().optional().nullable(),
	supplier_name: z.string().optional().nullable(),
	supplier_unit_cost: z.coerce.number().optional().nullable(),
	supplier_total_cost: z.number().optional().nullable(),
	created_at: z.string().optional().nullable(),
	updated_at: z.string().optional().nullable(),
});
export type Bom = z.infer<typeof bomSchema>;

export const formBomSchema = z.object({
	id: z.coerce.string().optional().nullable(),
	item_name: z.string().min(1, "Item name is required"),
	brand_model: z.array(z.string()).default([]),
	brand_origin: z.array(z.string()).default([]),
	specifications: z.record(z.string(), z.string()).optional().nullable().default({}),
	markup_rate: z.string().optional().nullable(),
	additional_costs: z.record(z.string(), z.coerce.number()).optional().nullable().default({}),
	warranty: z.coerce.number().optional().nullable(),
	period: z.string().optional().nullable(),
	quantity: z.coerce.number().min(1, "Quantity is required"),
	unit: z.enum(["each", "box", "roll", "set", "packs"]).default("each"),
	company_unit_cost: z.coerce.number().optional().nullable(),
	company_total_cost: z.coerce.number().optional().nullable(),
	bom_supplier_info_id: z.string().min(1, "Supplier is required"),
	supplier_unit_cost: z.coerce.number().min(0, "Supplier unit cost is required"),
	supplier_total_cost: z.coerce.number().optional().nullable(),
});
export type formBom = z.infer<typeof formBomSchema>;
// .omit removes the one that should not be included when user submits a form.
export const createBomSchema = bomSchema.omit({
	id: true,
	created_at: true,
	updated_at: true,
});
export type CreateBomData = z.infer<typeof createBomSchema>;

export const updateBomData = createBomSchema.partial().extend({
	id: z.string(),
});
export type UpdateBomData = z.infer<typeof updateBomData>;

// option schema for dropdowns and search where you only need a minimal data.
export const optionBomSchema = z.object({
	id: z.string(),
	item_name: z.string().optional().nullable(),
	specifications: z.record(z.string(), z.string()).optional().nullable(),
	brand_model: z.string().optional().nullable(),
	unit: z.enum(["each", "box"]),
	supplier_name: z.string().optional().nullable(),
});
export type OptionBom = z.infer<typeof optionBomSchema>;
